import {

    FETCH_TRACKING_HISTORY_PENDING,
    FETCH_TRACKING_HISTORY_FULFILLED,
    FETCH_TRACKING_HISTORY_REJECTED,

    DELETE_TRACKING_HISTORY_PENDING,
    DELETE_TRACKING_HISTORY_FULFILLED,
    DELETE_TRACKING_HISTORY_REJECTED,

    CHANGE_TRACKING_HISTORY

} from './trackingHistoryActions'

const moment = require('moment');
const initialState = {
    loading: false,
    listOfTrackingHistory: [],
    trackingHistory: {
        veiculo: 0,
        velocidadeTipo: 0,
        velocidadeValor: 0,
        dataInicial: moment().utc().format("DD/MM/YYYY"),
        horaInicial: '00:00:00',
        dataFinal: moment().utc().format("DD/MM/YYYY"),
        horaFinal: moment().format("HH:mm:ss"),
        dataHoraInicial: moment().utc().format("YYYY-MM-DD") + ' 00:00:00',
        dataHoraFinal: moment().utc().format("YYYY-MM-DD HH:mm:ss"),
    },
    error: null,
}

export function trackingHistoryReducer(state = initialState, action) {
    switch (action.type) {
        case CHANGE_TRACKING_HISTORY:
            return Object.assign({}, state, {
                trackingHistory: {
                    ...state.trackingHistory,
                    [action.payload.name]: action.payload.value
                }
            })
        case FETCH_TRACKING_HISTORY_PENDING:
            return Object.assign({}, state, {
                loading: true,
                listOfTrackingHistory: [],
            })
        case FETCH_TRACKING_HISTORY_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
                listOfTrackingHistory: action.payload
            })
        case FETCH_TRACKING_HISTORY_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                listOfTrackingHistory: [],
                error: action.payload
            })

        case DELETE_TRACKING_HISTORY_PENDING:
            return Object.assign({}, state, {
                loading: true,
            })
        case DELETE_TRACKING_HISTORY_FULFILLED:
            return Object.assign({}, state, {
                loading: false,
            })
        case DELETE_TRACKING_HISTORY_REJECTED:
            return Object.assign({}, state, {
                loading: false,
                error: action.payload
            })

        default:
            return state
    }
}